'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = Entities;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _caligramReact = require('caligram-react');

var _config = require('../config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Entities(props, _ref) {
  var polyglot = _ref.polyglot;
  var disclosed = props.disclosed,
      entities = props.entities,
      entitiesTree = props.entitiesTree,
      entity = props.entity,
      handleToggleDisclosure = props.handleToggleDisclosure,
      handleToggleShowAll = props.handleToggleShowAll,
      handleToggleTreeView = props.handleToggleTreeView,
      push = props.push,
      showAll = props.showAll,
      treeView = props.treeView;


  var backButtonAction = function backButtonAction() {
    push({ pathname: '/' });
  };

  var buildEntityLink = function buildEntityLink(entityName, en) {
    return _react2.default.createElement(
      'span',
      { className: 'entity' },
      _react2.default.createElement(
        _reactRouter.Link,
        { to: { pathname: '/evenements', query: (0, _defineProperty3.default)({ page: 1 }, entityName, en.id) } },
        en.name
      ),
      _react2.default.createElement(
        'span',
        { className: 'references' },
        en.references !== undefined ? en.references : ''
      )
    );
  };

  return _react2.default.createElement(
    _caligramReact.Page,
    { title: polyglot.t('event.entitiesAll.' + entity), backButtonAction: backButtonAction, layout: 'wide', className: 'Entities' },
    _config.app.show.entityFilters && _react2.default.createElement(
      'ul',
      { className: 'filters' },
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(_caligramReact.Checkbox, { title: polyglot.t('event.showAll', { entity: entity }), action: handleToggleShowAll, checked: showAll, id: 'toggleShowAll' })
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(_caligramReact.Checkbox, { title: polyglot.t('event.treeView'), action: handleToggleTreeView, checked: treeView, id: 'toggleTreeView' })
      )
    ),
    _react2.default.createElement(
      'ul',
      { className: 'entities ' + (treeView ? 'tree' : 'flat') },
      (treeView ? entitiesTree : entities).map(function (en) {
        var hasChildren = en.children && en.children.length > 0;
        var liProps = { key: en.id };
        var isDisclosed = true;

        if (treeView && hasChildren) {
          if (_config.app.show.disclosableEntities) {
            isDisclosed = disclosed.indexOf(en.id) > -1;
            liProps.className = 'parent ' + (_config.app.show.disclosableEntities && isDisclosed ? 'expanded' : 'collapsed');
          } else {
            liProps.className = 'parent';
          }
        }

        var title = isDisclosed ? polyglot.t('event.collapseEntity') : polyglot.t('event.expandEntity');
        var icon = isDisclosed ? 'chevronUp' : 'chevronDown';

        return _react2.default.createElement(
          'li',
          liProps,
          buildEntityLink(entity, en),
          _config.app.show.disclosableEntities && hasChildren && treeView && _react2.default.createElement(_caligramReact.Button, { title: title, action: function action() {
              return handleToggleDisclosure(en.id);
            }, hideTitle: true, iconLeft: icon }),
          treeView && hasChildren ? _react2.default.createElement(
            'ul',
            { className: 'children' },
            en.children.map(function (cEn) {
              return _react2.default.createElement(
                'li',
                { key: cEn.id },
                buildEntityLink(entity, cEn)
              );
            })
          ) : ''
        );
      })
    )
  );
}

Entities.contextTypes = {
  polyglot: _react.PropTypes.object
};

Entities.propTypes = {
  disclosed: _react.PropTypes.array,
  entities: _react.PropTypes.array,
  entitiesTree: _react.PropTypes.array,
  entity: _react.PropTypes.string,
  handleToggleDisclosure: _react.PropTypes.func,
  handleToggleShowAll: _react.PropTypes.func,
  handleToggleTreeView: _react.PropTypes.func,
  push: _react.PropTypes.func,
  showAll: _react.PropTypes.bool,
  treeView: _react.PropTypes.bool
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Entities.js
// module id = 1161
// module chunks = 0